import useGetLatestSubscription from '@/hooks/subscription/useGetLatestSubscription';
import { useScreen } from '@/hooks/useScreen';
import { ICollection } from '@/interfaces/doccen-lib/collection.interface';
import dynamic from 'next/dynamic';
import CollectionDetailProvider from 'state/collection/CollectionDetailProvider';

const DynamicCollectionDetailSideBar = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/collection-detail/CollectionDetailSideBar'
    )
);

const DynamicCollectionDetailBottomSheet = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/collection-detail/CollectionDetailBottomSheet'
    )
);

const CollectionDetailMoreInformation = (props: {
  collection: ICollection | undefined;
}) => {
  const { collection } = props;
  const { isDesktop } = useScreen();

  const { data: latestSubscription } = useGetLatestSubscription({});

  return (
    <CollectionDetailProvider
      collection={collection}
      latestSubscription={latestSubscription}
    >
      {!isDesktop ? (
        <DynamicCollectionDetailBottomSheet />
      ) : (
        <DynamicCollectionDetailSideBar />
      )}
    </CollectionDetailProvider>
  );
};

export default CollectionDetailMoreInformation;
